export class BaseEntity {
    id: number;
    errors: { [property: string]: string[] }; // propertyName => errormessages

    isValid(): boolean {
        return !this.errors || Object.keys(this.errors).length === 0;
    }

    public dateToString = function (date: Date) {
        if (!date) {
            return ''
        }

        var originalDate = new Date(date);

        const dd = originalDate.getDate();
        const mm = originalDate.getMonth() + 1; // January is 0!
        const yyyy = originalDate.getFullYear();

        var ddS = dd.toString();
        var mmS = mm.toString();

        if (dd < 10) {
            ddS = '0' + dd
        }

        if (mm < 10) {
            mmS = '0' + mm
        }

        return ddS + '/' + mmS + '/' + yyyy;
    }
}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/core/models/base-entity.model.ts